<template>
  <el-select v-bind="$attrs" :model-value="modelValue" clearable :filterable="dataSource.length>10">
    <el-option
      v-for="item in dataSource"
      :key="item[valueKey]"
      :label="item[labelKey]"
      :value="item[valueKey]">
      <slot name="option" :data="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'com-select',
  props: {
    modelValue: [String, Number, Array, Boolean],
    dataSource: { // 下拉项
      type: Array,
      default: () => [],
    },
    labelKey: {
      type: String,
      default: 'dictLabel',
    },
    valueKey: {
      type: String,
      default: 'dictValue',
    }
  },
  data () {
    return {}
  },
  created () {
  }
}
</script>